import { useCallback, useContext } from 'react';
import {
	enuanLocalStorage,
	updateStorageTimestamp,
} from '../utils/enuanLocalStorage';
import { DropLast } from '@avalenti89/typescript-utils';
import { configurationContext } from '../contexts/configuration';

export const useEnuanLocalStorage = () => {
	const { m3_ep = 'chat' } = useContext(configurationContext);

	const get = useCallback(
		(...attrs: DropLast<Parameters<(typeof enuanLocalStorage)['get']>>) =>
			enuanLocalStorage.get(...attrs, m3_ep),
		[m3_ep],
	);
	const set = useCallback(
		(...attrs: DropLast<Parameters<(typeof enuanLocalStorage)['set']>>) =>
			enuanLocalStorage.set(...attrs, m3_ep),
		[m3_ep],
	);
	const parseKey = useCallback(
		(...attrs: DropLast<Parameters<(typeof enuanLocalStorage)['parseKey']>>) =>
			enuanLocalStorage.parseKey(...attrs, m3_ep),
		[m3_ep],
	);
	const unset = useCallback(
		(...attrs: DropLast<Parameters<(typeof enuanLocalStorage)['unset']>>) =>
			enuanLocalStorage.unset(...attrs, m3_ep),
		[m3_ep],
	);

	const _updateStorageTimestamp = useCallback(
		(...attrs: DropLast<Parameters<typeof updateStorageTimestamp>>) =>
			updateStorageTimestamp(...attrs, m3_ep),
		[m3_ep],
	);

	return {
		get,
		set,
		unset,
		parseKey,
		updateStorageTimestamp: _updateStorageTimestamp,
	};
};
